import { ConfirmIdentity } from '@vfit/shared/components';
import { ICheckoutData } from '../../checkoutEnergy.models';
import TaggingConfirmIdentityCard from './confirmIdentityCard.tagging';
import { useEnergyCheckout } from '../../../energy.context';
import {
  CONSUMER_CMS_SHOPPING_CART,
  IPersonalInfoCmsMobile,
  IUserIdentityField,
} from '@vfit/consumer/data-access';
import { useCmsConfig } from '@vfit/business-data-access';
import { API, getClickToCallWithKeyOrUrl, trackLink } from '@vfit/shared/data-access';
import { useEffect } from 'react';
import { organizeConfirmIdentityCard } from './confirmIdentityCard.utils';
import { Button } from '@vfit/shared/atoms';
import { ButtonWrapper } from './confirmIdentityCard.style';
import { useQueryClient } from 'react-query';

const ConfirmIdentityCard = ({ handleOnChangeEnableGoNext, handleGoNextSlide }: ICheckoutData) => {
  const { findCaller, product, setFindCaller } = useEnergyCheckout();
  const client = useQueryClient();
  const handleSelect = (selectedItem: IUserIdentityField) => {
    setFindCaller({
      ...findCaller,
      selectedContactMedium: selectedItem.field?.trim() ? selectedItem : undefined,
    });
  };

  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA_ENERGY
  ) as IPersonalInfoCmsMobile;
  const { descriptionCms, placeholderCms, titleCms, ctaLabelCms, ctaUrl } =
    organizeConfirmIdentityCard(dataFromCms, product);
  const cardConfig = {
    getSelectedData: handleSelect,
    identityTypeItems: [
      findCaller.individualRef?.email || '',
      findCaller.individualRef?.msisdn || '',
    ],
    title: titleCms,
    description: descriptionCms,
    placeholder: placeholderCms,
    cta: {
      label: ctaLabelCms,
      url: ctaUrl,
      action: () => {
        if (product?.urlClickToCallOtp) {
          trackLink(`verify id:${ctaLabelCms?.toLowerCase()}`);
          getClickToCallWithKeyOrUrl(client, product?.urlClickToCallOtp, product);
        } else if (ctaUrl) {
          trackLink(`verify id:${ctaLabelCms?.toLowerCase()}`);
          window.location.href = ctaUrl;
        } else {
          null;
        }
      },
    },
  };

  useEffect(() => {
    if (handleOnChangeEnableGoNext) {
      handleOnChangeEnableGoNext(
        !!(findCaller.selectedContactMedium?.field && findCaller.selectedContactMedium.fieldType)
      );
    }
  }, [findCaller.selectedContactMedium]);

  useEffect(() => {
    setFindCaller({
      ...findCaller,
      selectedContactMedium: undefined,
    });
  }, []);

  return (
    <>
      <TaggingConfirmIdentityCard />
      <ConfirmIdentity
        data={cardConfig}
        children={
          <ButtonWrapper>
            <Button
              onClick={() => handleGoNextSlide?.()}
              variant="primary"
              disabled={!findCaller.selectedContactMedium?.field}
            >
              {product.buttons?.[0]?.label || 'Prosegui'}
            </Button>
          </ButtonWrapper>
        }
      />
    </>
  );
};

export default ConfirmIdentityCard;

